import { render, staticRenderFns } from "./ButtonIconSmall.vue?vue&type=template&id=3732812c&"
import script from "./ButtonIconSmall.vue?vue&type=script&lang=js&"
export * from "./ButtonIconSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports